import { useNavigate } from "react-router-dom";
import type { Prompt } from "@akhshy/types";
import { CopyButton } from "../atoms/CopyButton.tsx";
import { LaunchInLlm } from "../atoms/LaunchInLlm.tsx";
import { client } from "../../lib/api.ts";
import { useCount } from "../../lib/counts.ts";

export function PromptCard({ prompt }: { prompt: Prompt }) {
  const navigate = useNavigate();
  const copies = useCount("prompt", prompt.id);

  const recordCopy = () => {
    // Fire-and-forget; never let analytics break the copy UX.
    void client.metrics.recordPromptCopied(prompt.id).catch(() => {});
  };

  // Open the prompt as a popup at its own shareable URL.
  const open = () => navigate(`/prompts/${prompt.slug ?? prompt.id}`);

  return (
    <article className="prompt-card">
      <p className="use-case">
        {prompt.useCase}
        {copies !== null && <span className="use-count marker">copied {copies}×</span>}
      </p>
      <h4>{prompt.title}</h4>
      <div className="prompt-text-wrap">
        <pre className="prompt-text">{prompt.body}</pre>
      </div>
      <div className="prompt-actions">
        <CopyButton text={prompt.body} onCopied={recordCopy} />
        <LaunchInLlm promptId={prompt.id} body={prompt.body} />
        <button type="button" className="expand-btn" onClick={open}>
          read full prompt →
        </button>
      </div>
    </article>
  );
}
